/**
 * @desc getBySkuNo
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.WarehouseSkuBatchQueryRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/warehouseSku/getBySkuNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
